
const fullReductionRouters = [
  { path: '/createFullReduction', component: () => import('@/views/fullReduction/createFullReduction/index.vue') },
  { path: '/manageFullReduction', component: () => import('@/views/fullReduction/manageFullReduction/index.vue') },
  { path: '/detailFullReduction', component: () => import('@/views/fullReduction/detailFullReduction/index.vue') },
  { path: '/freightQuery', component: () => import('@/views/freight/freightQuery/index.vue') },
  { path: '/reservationService', component: () => import('@/views/freight/reservationService/index.vue') },
  { path: '/addFreight', component: () => import('@/views/freight/addFreight/index.vue') },
  { path: '/cloudFilmRecords', component: () => import('@/views/freight/cloudFilmRecords/index.vue') }
]

export default fullReductionRouters
